import { apiInstanceFetch } from "../../../util/api";
import * as ActionType from "./rewardWallet.type";

export const getWallets =
  (page, limit, status = "all", search = "") =>
  (dispatch) => {
    let url = `rewardWallet/listWallets?page=${page}&limit=${limit}`;
    if (status && status !== "all") url += `&status=${encodeURIComponent(status)}`;
    if (search && search.trim() !== "") url += `&search=${encodeURIComponent(search.trim())}`;

    apiInstanceFetch
      .get(url)
      .then((res) => {
        if (!res?.status) return;
        dispatch({
          type: ActionType.GET_WALLETS,
          payload: { wallets: res.wallets || [], pagination: res.pagination },
        });
      })
      .catch((err) => console.error("getWallets:", err));
  };

export const getWalletStats = () => (dispatch) => {
  apiInstanceFetch
    .get("rewardWallet/walletStats")
    .then((res) => {
      if (!res?.status) return;
      dispatch({
        type: ActionType.GET_WALLET_STATS,
        payload: { stats: res.stats, bySource: res.bySource || [] },
      });
    })
    .catch((err) => console.error("getWalletStats:", err));
};

export const getRewardTransactions =
  (page, limit, type = "all", source = "all", search = "", startDate = "All", endDate = "All") =>
  (dispatch) => {
    let url = `rewardWallet/listAllTransactions?page=${page}&limit=${limit}`;
    if (type && type !== "all") url += `&type=${encodeURIComponent(type)}`;
    if (source && source !== "all") url += `&source=${encodeURIComponent(source)}`;
    if (search && search.trim() !== "") url += `&search=${encodeURIComponent(search.trim())}`;
    if (startDate && startDate !== "All") url += `&startDate=${startDate}`;
    if (endDate && endDate !== "All") url += `&endDate=${endDate}`;

    apiInstanceFetch
      .get(url)
      .then((res) => {
        if (!res?.status) return;
        dispatch({
          type: ActionType.GET_REWARD_TRANSACTIONS,
          payload: {
            transactions: res.transactions || [],
            pagination: res.pagination,
            stats: res.stats,
          },
        });
      })
      .catch((err) => console.error("getRewardTransactions:", err));
  };

export const getEarningRules = () => (dispatch) => {
  apiInstanceFetch
    .get("rewardWallet/getEarningRules")
    .then((res) => {
      if (!res?.status) return;
      dispatch({ type: ActionType.GET_EARNING_RULES, payload: res.rules || [] });
    })
    .catch((err) => console.error("getEarningRules:", err));
};

export const setWalletStatus =
  (userId, status, adminId, note, onDone) =>
  (dispatch) => {
    apiInstanceFetch
      .post(
        "rewardWallet/setStatus",
        { userId, status, adminId, note }
      )
      .then((res) => {
        if (!res?.status) {
          alert(res?.message || "Failed to update status.");
          if (onDone) onDone(false);
          return;
        }
        dispatch({ type: ActionType.UPDATE_WALLET_STATUS, payload: res.wallet });
        if (onDone) onDone(true);
      })
      .catch((err) => {
        console.error("setWalletStatus:", err);
        if (onDone) onDone(false);
      });
  };

export const adminAdjustWallet =
  (userId, amount, note, adminId, onDone) =>
  (dispatch) => {
    apiInstanceFetch
      .post(
        "rewardWallet/adminAdjust",
        { userId, amount, note, adminId }
      )
      .then((res) => {
        if (!res?.status) {
          alert(res?.message || "Failed to adjust wallet.");
          if (onDone) onDone(false);
          return;
        }
        dispatch({ type: ActionType.WALLET_ADJUSTED, payload: res.wallet });
        if (onDone) onDone(true);
      })
      .catch((err) => {
        console.error("adminAdjustWallet:", err);
        if (onDone) onDone(false);
      });
  };

export const updateEarningRule =
  (patch, adminId, onDone) =>
  (dispatch) => {
    apiInstanceFetch
      .post(
        "rewardWallet/updateEarningRule",
        { ...patch, adminId }
      )
      .then((res) => {
        if (!res?.status) {
          alert(res?.message || "Failed to update rule.");
          if (onDone) onDone(false);
          return;
        }
        dispatch({ type: ActionType.UPDATE_EARNING_RULE, payload: res.rule });
        if (onDone) onDone(true);
      })
      .catch((err) => {
        console.error("updateEarningRule:", err);
        if (onDone) onDone(false);
      });
  };
